import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { theme } from 'theme';
import { useTheme } from '@mui/material';



export type ColorsProps = {};

const __generateColorElements = (color: keyof typeof theme['palette']) => {
  const theme = useTheme();
  const colorOptions = Object.keys(theme.palette[color]);

  const elements = colorOptions.map((option) => {
    if (theme.palette[color][option as keyof typeof theme['palette'][typeof color]]) {
      return (
        <Stack flex='' key={option} direction='column'>
          <Box width='50px' height='50px' bgcolor={(theme) => theme.palette[color][option as keyof typeof theme['palette'][typeof color]]} />
          <Typography variant='h4'>{option}</Typography>
        </Stack>
      );
    } else return (
      <Stack flex='' key={option} direction='column'>
        <Box width='50px' height='50px' bgcolor={(theme) => theme.palette[color][option as keyof typeof theme['palette'][typeof color]]} />
        <Typography variant='h4'></Typography>
      </Stack>
    );
  });
  return (
    <Box >
      <Typography variant='h3'>{color.toUpperCase()}</Typography>
      <Box display='flex' flexWrap='wrap' columnGap={2}>
        {elements}
      </Box>
    </Box>
  );
};

export const Colors = (props: ColorsProps) => {
  const colors: (keyof typeof theme.palette)[] = Object.keys(theme.palette).map((node) => node as keyof typeof theme.palette);
  return (
    <Box display='flex' flexDirection='column' rowGap={4}>
      {colors.map((color) => {
        if (
          color !== 'mode'
          && color !== 'getContrastText'
          && color !== 'contrastThreshold'
          && color !== 'augmentColor'
          && color !== 'divider'
          && color !== 'tonalOffset'
        ) {
          return __generateColorElements(color);
        }
      })}

    </Box>
  );
};
